module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"My Freight Online","short_name":"mfo","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/resources/img/favicon/favicon.png","icon_options":{"purpose":"any maskable"},"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"930ed455aee675edd7ad3da87abf0e34"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
